const minifiedHeader = (options) => {
  const {
    headerDiv,
    minClass,
  } = options;
  if (!headerDiv) {
    return;
  }
  let isAccessibleHeader = false;
  const headerContentDiv = document.querySelector('.header-main-section');
  // Check to see if .promo-bar is added
  let addOffsetDiv = document.querySelector('main');
  const promoBar = document.querySelector('.promo-bar');
  if (promoBar) {
    addOffsetDiv = promoBar;
  }
  headerDiv.classList.add(minClass);

  const setHeaderHeightVar = (offsetBy) => {
    document.documentElement.style.setProperty('--header-height', `${offsetBy}px`);
  };

  const setHeaderOffset = () => {
    if (isAccessibleHeader) {
      return;
    }
    let offsetBy = headerContentDiv.offsetHeight;
    const aboveHeaderPromoDiv = document.querySelector('.above-header-promo');
    if (aboveHeaderPromoDiv) {
      offsetBy += aboveHeaderPromoDiv.offsetHeight;
    }
    addOffsetDiv.style.marginTop = `${offsetBy}px`;
    setHeaderHeightVar(offsetBy);
  };

  const clearHeaderOffset = () => {
    addOffsetDiv.removeAttribute('style');
    setHeaderHeightVar(0);
  };

  const enableAccessibleHeader = () => {
    // Check to see if dropdown is open and add to header height
    const activeSubnav = document.querySelector('.subnav.is-active');
    let height = headerContentDiv.offsetHeight;
    if (activeSubnav) {
      const subnav = activeSubnav.querySelector('.dd-nav-wrap');
      height += subnav.offsetHeight;
    }
    if (height > window.innerHeight) {
      isAccessibleHeader = true;
      headerDiv.classList.remove(minClass);
      clearHeaderOffset();
    }
  };

  const onResize = () => {
    setHeaderOffset();
    enableAccessibleHeader();
  };

  const onScroll = () => {
    enableAccessibleHeader();
  };

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onResize);
  setHeaderOffset();
  enableAccessibleHeader();
};

export default minifiedHeader;
